export default __webpack_public_path__ + "static/media/mining.6214747c.png";